import { TaxNoticeType } from '@/components/covalent/tax/notice/TaxNoticeType';

enum TaxNoticeStatus {
  ALL = 0,
  STAY = 100,
  DONE = 200,
}

export const allCases = [TaxNoticeStatus.ALL, TaxNoticeStatus.STAY, TaxNoticeStatus.DONE];

export const colors = (type: number, status: number) => {
  if (type === TaxNoticeType.CUSTOM) {
    return 'default';
  }
  switch (status) {
    case TaxNoticeStatus.STAY:
      return 'default';
    case TaxNoticeStatus.DONE:
      return 'processing';
    default:
      return 'processing';
  }
};

export const messages = (status: number) => {
  switch (status) {
    case TaxNoticeStatus.ALL:
      return '전체';
    case TaxNoticeStatus.STAY:
      return '민원대기';
    case TaxNoticeStatus.DONE:
      return '민원완료';
    default:
      return '대기중';
  }
};

export default TaxNoticeStatus;
